import React, { Fragment, useState } from 'react'
import { ButtonGhostV2, UI_BODY_SEMIBOLD_SM_DF, UI_CAPTION_DF, getBreakPoint, useScreenWidth, DropdownSingle, icons, Divider, colors, colors2, UI_CAPTION_SEMIBOLD_DF } from 'oolib';
import { useNavigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';

import { useLogout } from '../../../../../../../utils/react-query-hooks/auth';
import { useGetQueryData } from '../../../../../../../utils/react-query-hooks/general';

import { MyDashboardNavMenu } from '../../../../../MyDashboardMenu';
import { useIsThisLinkActive } from '../../utils/useIsThisLinkActive';
import { useGetMyAccountMenuOptions } from './utils/useGetMyAccountMenuOptions';
import { usePlatformBuilderContext } from '../../../../../../../contexts/platformBuilderContext';
import { StyledMyAccountMenuButton } from '../../../styled';
import {
  StyledMyAccountMenuWrapper,
  StyledMyAccountMenuTrigger,
  StyledMyAccountMenuOptions,
  StyledMyAccountMenuOption
} from './styled';
import { RotatingCaret } from '@/components/generalUI/RotatingCaret';
import { HeaderBreakpoint } from '@/CONSTANTS/hooks/useHeaderHeight';
import { ProfileImageInput } from '@/components/media/ImageInput';


export const MyAccountMenu = () => {

    const screenWidth = useScreenWidth()
    const navigate = useNavigate()
    const LG = screenWidth >= getBreakPoint(HeaderBreakpoint)
    const [showDashboardMenu, setShowDashboardMenu] = useState(false);
    const {inGlobalNavBuilder} = usePlatformBuilderContext()
    const {getActiveMenuOption} = useIsThisLinkActive()
    const { colors } = useTheme()
    const myAccountMenuOptions = useGetMyAccountMenuOptions()

    const {logout} = useLogout()

    const {user} = useGetQueryData('userData') || {}

    const genCustomSelectComp = (onClick) => (
    <div onClick={onClick} style={{ cursor: "pointer" }}> {/* Id required of Coachmarks */}
      <ButtonGhostV2
        responsive
        style={{ borderRadius: "3.7rem", paddingLeft: "1.4rem", paddingRight: "1.4rem" }} 
        icon="User" 
        iconSize={"S"} 
        id={"OKE-Header-myAccountMenuButton"} 
        children={user?.name.split(' ')[0]} 
      />
      {/* <StyledMyAccountMenuButton > 
        <ProfileImageInput
          readOnly
          value={user?.avatar?.userUploaded}
          size={30}
          imageTitle={user?.name}
          />
      </StyledMyAccountMenuButton> */}
    </div>
  );

  const handleChange = (k, v) => {
    if (inGlobalNavBuilder)  return;

    if (v.value === "logout") {
      logout();
    } else {
        navigate(v.to);
    }
  };

  const MyAccountMenuMobile = ({ open, onClose, onOpen }) => {
    return (
      <StyledMyAccountMenuWrapper colors={colors}>

        <StyledMyAccountMenuTrigger open={open} onClick={open ? onClose : onOpen}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
            <ProfileImageInput
              readOnly
              value={user?.avatar?.userUploaded}
              size={40}
              imageTitle={user?.name}
            />

            <UI_BODY_SEMIBOLD_SM_DF>{user?.name}</UI_BODY_SEMIBOLD_SM_DF>
          </div>
          <RotatingCaret iconSize={20} position={open ? 'up' : 'down'} />
        </StyledMyAccountMenuTrigger>

        <StyledMyAccountMenuOptions open={open} onClick={e => e.stopPropagation()}>
          {open && <Divider style={{ borderBottom: `1px solid ${colors2.grey10}` }}/>}
          <div style={{ paddingTop: '0.5rem' }}>
            {myAccountMenuOptions.filter(opt => opt.value !== 'logout').map((opt, idx) => {
              const Icon = icons[opt.icon] || icons.User;
              return (
                <StyledMyAccountMenuOption
                  key={opt.value}
                  onClick={() => {
                    setShowDashboardMenu(false);
                    if (inGlobalNavBuilder) return;
                    navigate(opt.to);
                  }}
                >
                  <UI_BODY_SEMIBOLD_SM_DF>{opt.display}</UI_BODY_SEMIBOLD_SM_DF>
                </StyledMyAccountMenuOption>
              );
            })}
            <StyledMyAccountMenuOption
              logout
              onClick={() => {
                setShowDashboardMenu(false);
                logout();
              }}
            >
              <UI_BODY_SEMIBOLD_SM_DF>Logout</UI_BODY_SEMIBOLD_SM_DF>
            </StyledMyAccountMenuOption>
          </div>
        </StyledMyAccountMenuOptions>
      </StyledMyAccountMenuWrapper>
    );
  };

  if(LG){
    return (
      <DropdownSingle
        id='myAccountMenu'
        className='OKE-Header__myAccountMenu'
        genCustomSelectComp={genCustomSelectComp}
        value={getActiveMenuOption({options: myAccountMenuOptions})}
        options={myAccountMenuOptions}
        onChange={(k, v) => handleChange(k, v)}
        optionsAnchor='right'
        optionsClassName={'UI_BODY_SEMIBOLD_SM'}
      />
    );
  }else{
    return (
      <Fragment>
        <MyAccountMenuMobile
          open={showDashboardMenu}
          onOpen={() => setShowDashboardMenu(true)}
          onClose={() => setShowDashboardMenu(false)}
        />
        <Divider style={{ borderBottom: `1px solid ${colors2.grey10}` }}/>
      </Fragment>
    )
  }

  
};